import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import enResource from './en/resource'

i18n.use(initReactI18next).init({
  resources: {
    en: enResource,
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
